import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { CreditAccountAlertComponent } from './credit-account-alert.component';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        MaterialModule
    ],
    declarations: [CreditAccountAlertComponent],
    exports: [CreditAccountAlertComponent]
})
export class CreditAccountAlertModule {
}
